// extracted by mini-css-extract-plugin
module.exports = {"hotspot":"Hotspot_hotspot__2V3aU","visibleHotspot":"Hotspot_visibleHotspot__3VPdK"};